module.exports = __webpack_public_path__ + "static/media/izlozba (12).dab88711.jpg";